<template>
  <v-layout>
    <v-dialog
      v-if="$route.name !== 'totem'"
      lazy
      hide-overlay
      full-width
      persistent
      v-model="dialog"
      id="checkout-modal"
    >
      <v-flex xs12 sm11 md10 lg9 xl8 mx-auto>
        <v-flex xs12>
          <modal-header
            :imgUrl="eventImgUrl"
            :name="eventName"
            :place="eventPlace"
            :date="eventDate"
            @exit="closeDialog"
          />
        </v-flex>
        <!-- Ocultando steps do checkout -->
        <div v-if="false">
          <v-flex xs12 v-if="currentStep !== 5">
            <modal-steps :steps="steps" :currentStep="currentStep" />
          </v-flex>
        </div>
        <!--  -->
        <v-flex xs12>
          <modal-sector-header
            v-if="sectorMap && sectorMap.length > 1 && !showDefault"
          />
        </v-flex>
        <v-flex xs12>
          <modal-content />
        </v-flex>
        <modal-footer />
      </v-flex>
    </v-dialog>
    <v-flex v-else mt-4 xs12 sm12 md12 lg12 xl12 mx-auto>
      <v-flex xs12>
        <modal-header
          :imgUrl="eventImgUrl"
          :name="eventName"
          :place="eventPlace"
          :date="eventDate"
          @exit="closeDialog"
        />
      </v-flex>
      <!-- Ocultando steps do checkout -->
      <div v-if="false">
        <v-flex xs12 v-if="currentStep !== 5">
          <modal-steps :steps="steps" :currentStep="currentStep" />
        </v-flex>
      </div>
      <!--  -->
      <v-flex xs12>
        <modal-sector-header
          v-if="sectorMap && sectorMap.length > 1 && !showDefault"
        />
      </v-flex>
      <v-flex xs12>
        <modal-content />
      </v-flex>
      <modal-footer />
    </v-flex>
  </v-layout>
</template>

<script>
import ModalHeader from './ModalHeader.vue';
import ModalSteps from './ModalSteps.vue';
import ModalContent from './ModalContent.vue';
import ModalFooter from './ModalFooter.vue';
import ModalSectorHeader from './ModalSectorHeader.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ModalHeader,
    ModalSteps,
    ModalContent,
    ModalFooter,
    ModalSectorHeader,
  },
  watch: {
    async dialog(value) {
      if (value && !this.addedMouseflow) {
        this.addMouseFlow();
        this.addedMouseflow = true;
      }
      if (value && this.currentStep === 1) {
        try {
          var evento;
          if (
            window.location.pathname.split('/') &&
            window.location.pathname.split('/')[1]
          ) {
            evento = window.location.pathname.split('/')[1];
          } else {
            evento = this.evento ? this.evento : null;
          }
          var appToken;
          if (
            window.location.search.substring(4, window.location.search.length)
          ) {
            appToken = window.location.search.substring(
              4,
              window.location.search.length
            );
            this.$store.commit('SET_CLIENT_TOKEN', appToken);
            const checkoutState =
              JSON.parse(localStorage.getItem(`checkoutState`)) || {};
            if (
              appToken &&
              checkoutState &&
              checkoutState[evento] &&
              checkoutState[evento].userToken
            )
              this.$store.dispatch('getClientData');
          }
          if (this.$route.name === 'commissioner') {
            await this.$store.dispatch(
              'getOrderDetails',
              this.$route.params.hash
            );
            // .then(resp => {
            //   this.$store.dispatch('setCurrentStep', 2);
            // })
          } else {
            this.$store.dispatch('setEventID', evento);
          }
          await this.$store.dispatch('fetchEventData');
          this.addTikTokPixel();
          let uuid = JSON.parse(
            localStorage.getItem(`queue_uuid_${this.eventDetails.codigo}`)
          );
          if (
            this.queue &&
            !this.showPreSale &&
            this.eventDetails.site_visibilidade !== 'Y'
          )
            this.$store
              .dispatch('getQueue', {
                event: this.eventDetails.codigo,
                uuid: uuid ? uuid.uuid : '',
              })
              .then(resp => {
                let obj = {
                  uuid: resp.data.uuid,
                  position: resp.data.position,
                };
                this.$store.commit('SET_QUEUE_TEXT', resp.data.text);
                this.$store.commit('SET_POSITION', resp.data.position);
                if (resp.data.status === 'L') {
                  this.$store.dispatch('setSectorsList');
                  this.$store.commit('SET_SHOW_QUEUE', false);
                  this.$store.commit('SET_MESSAGE_QUEUE', true);
                  if (this.$route.name === 'commissioner') {
                    this.$store.dispatch(
                      'getOrderDetails',
                      this.$route.params.hash
                    );
                  }
                }
                localStorage.setItem(
                  `queue_uuid_${evento}`,
                  JSON.stringify(obj)
                );
              });
          await this.$store.dispatch('loadCheckoutState', evento);
          const iframePurcheased = JSON.parse(
            localStorage.getItem('iframePurcheased')
          );
          if (iframePurcheased) {
            await this.$store.dispatch('deleteCheckoutState', evento);
            if (appToken) await this.$store.dispatch('getClientData');
            await this.$store.dispatch('loadCheckoutState', evento);
            localStorage.setItem('iframePurcheased', false);
          }
        } catch (error) {
          if (
            !this.saleUninitiated &&
            !this.$route.query.listar_apresentacoes
          ) {
            this.$store.dispatch('openSnackbar', {
              message:
                'Erro ao carregar os itens do checkout. Tente novamente.',
            });
          }
        }
      }
    },
    currentStep(value) {
      if (value === 5) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        document.getElementsByClassName(
          'v-dialog v-dialog--active'
        )[0].scrollTop = 0;
      }
    },
  },
  data() {
    return {
      addedMouseflow: false,
      dialog: false,
      evento: null,
      userToken: null,
      steps: ['Ingressos', 'Entrega', 'Informações', 'Pagamento'],
    };
  },
  computed: {
    ...mapGetters(['showPreSale']),

    currentStep() {
      return this.$store.getters.currentStep;
    },
    saleUninitiated() {
      return this.$store.getters.saleUninitiated;
    },
    queue() {
      return this.$store.getters.queue;
    },
    sectorMap() {
      return this.$store.getters.sectorMap;
    },
    eventImgUrl() {
      return this.$store.getters.eventImgUrl;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    eventName() {
      return this.$store.getters.eventName;
    },
    eventPlace() {
      return this.$store.getters.eventPlace;
    },
    showDefault() {
      return this.$store.getters.showDefault;
    },
    eventDate() {
      return this.$store.getters.eventDate;
    },
    tiktokPixel() {
      return this.eventDetails &&
        this.eventDetails.integracoes_publicas &&
        this.eventDetails.integracoes_publicas.find(i => i.tipo === 'tiktok')
        ? this.eventDetails.integracoes_publicas.find(i => i.tipo === 'tiktok')
            .credenciais.token
        : '';
    },
  },

  methods: {
    closeDialog() {
      if (this.currentStep === 5) {
        this.$store.dispatch('deleteCheckoutState', this.evento);
      }
      // Iframe - Serve caso checkout for um 'iframe'
      this.$store.dispatch('sendPostMessage', {
        open: false,
      });
      // Iframe - Fim
      this.dialog = false;
    },
    addMouseFlow() {
      var mf = document.createElement('script');
      mf.type = 'text/javascript';
      mf.defer = true;
      mf.src =
        '//cdn.mouseflow.com/projects/b6ac3aef-2e2a-4c74-a362-46db475ab6cc';
      document.getElementsByTagName('head')[0].appendChild(mf);
    },
    addTikTokPixel() {
      if (this.tiktokPixel) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `!function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
          ttq.load('${this.tiktokPixel}');
          ttq.page();
        }(window, document, 'ttq');`;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    },
  },
  created() {
    // Iframe - Serve caso checkout for um 'iframe'
    const self = this;
    window.addEventListener(
      'message',
      function(e) {
        if (typeof e.data.open !== 'undefined') {
          self.dialog = !!e.data.open;
          self.evento = e.data.evento || null;
          if (e.data.ht) {
            self.$store.commit('SET_HT_BY_SITE');
            localStorage.setItem('ht', JSON.stringify(e.data.ht));
          }
          if (e.data.cupom) self.$store.dispatch('setUrlCupom', e.data.cupom);
          if (e.data.refererNatal)
            self.$store.dispatch('setRefererNatal', e.data.refererNatal);
          if (e.data.fbc || e.data.fbp)
            self.$store.dispatch('setFbcFbp', {
              fbp: e.data.fbp,
              fbc: e.data.fbc,
            });
          self.userToken = e.data.userToken || null;
          if (self.userToken) {
            self.$store.commit('SET_CLIENT_TOKEN', self.userToken);
            self.$store.dispatch('getClientData');
          } else {
            self.$store.dispatch('setBuyerData', {}); // comprador
            self.$store.dispatch('clearUserProps', {}); // usuário logado
            self.$store.dispatch('setSignSteps', {
              logged: false,
              signForm: true,
              step: 0,
            });
          }
        }
      },
      false
    );
    // Iframe - fim
    this.dialog = false;
  },
  mounted() {
    if (window.location.pathname.replace('/', '')) {
      this.dialog = true;
    }
    this.$store.dispatch('sendPostMessage', {
      ready: true,
    });
  },
};
</script>
